const state = {
    delivery: [],
    deliveryid: [],
    item: [],
    itemid: [],
    status: [],
    signature: [],
    signatureid: [],
    loading: false
};

export default state;